import { useQuery } from '@tanstack/react-query';
import type { Session } from '../../api/session';
import { getAllAddresses } from '../../api/tenant';
import { Skeleton } from '../../ui/Skeleton';
import p from '../passes/passes.module.css';
import s from './more.module.css';

/** All addresses of the resident, including ones held by a power of attorney. */
export function AddressesScreen({ session }: { session: Session }) {
  const addresses = useQuery({ queryKey: ['all-addresses'], queryFn: () => getAllAddresses(session) });
  return (
    <main className={p.page}>
      <h1 className={p.title}>Мои адреса</h1>
      {!addresses.data ? (
        <Skeleton height={120} />
      ) : addresses.data.length === 0 ? (
        <p className={p.empty}>Адресов нет</p>
      ) : (
        <ul className={p.list}>
          {addresses.data.map((a) => (
            <li key={`${a.object?.id}-${a.id}`} className={s.row}>
              <span className={s.rowText}>
                <span className={s.rowName}>{a.name}</span>
                <span className={s.rowSub}>{a.object?.name}</span>
                {a.confidanceId !== 0 && <span className={s.mark}>по доверенности</span>}
                {a.isBlocked && <span className={s.markBad}>заблокирован УК</span>}
              </span>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
